import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { openProjectWizard } from '../../util/evaluationsNavigation';

type Props = {
  project: { _id: string; name: string; number?: string | null };
  projectUrl: string;
};

const ProjectEvaluationRedirect = ({ project, projectUrl }: Props) => {
  const history = useHistory();
  // A second run would replace the wizard entry it just pushed
  const opened = useRef(false);

  useEffect(() => {
    if (opened.current) return;
    opened.current = true;
    openProjectWizard(history, project, projectUrl);
  }, [history, project, projectUrl]);

  return null;
};

export default ProjectEvaluationRedirect;
